import { SvgIcon } from "@mui/material";
import { Bank, Settings01 } from "@untitled-ui/icons-react";
import { ClipboardCheck, CoinsHand, Cube01, File07, BankNote03 } from "@untitled-ui/icons-react/build/esm";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { paths } from "~/paths";
import { useGetCurrentCompanyCache } from "~/queries/useGetCurrentCompany";
import type { ReactNode } from "react";
import { usePermissionFilters } from "~/hooks/use-permission-filters";
export interface Item {
  disabled?: boolean;
  external?: boolean;
  icon?: ReactNode;
  items?: Item[];
  label?: ReactNode;
  path?: string;
  title: string;
}
export interface Section {
  items: Item[];
  subheader?: string;
}
export const useSections = () => {
  const {
    data
  } = useGetCurrentCompanyCache();
  const {
    t
  } = useTranslation();
  const permissions = usePermissionFilters();
  return useMemo<Section[]>(() => {
    return [{
      items: [{
        title: data?.fileAlias?.plural ?? "",
        path: paths.index,
        icon: <SvgIcon fontSize="small">
								<ClipboardCheck />
							</SvgIcon>
      }]
    }, permissions.VIEW_AGENT && {
      items: [{
        title: "Agents",
        path: paths.agents.list,
        icon: <SvgIcon fontSize="small">
								<CoinsHand />
							</SvgIcon>
      }]
    }, permissions.VIEW_CLIENT && {
      items: [{
        title: "Clients",
        path: paths.clients.list,
        icon: <SvgIcon fontSize="small">
								<Bank />
							</SvgIcon>
      }]
    }, permissions.VIEW_PRODUCT && {
      items: [{
        title: "Products",
        path: paths.products.list,
        icon: <SvgIcon fontSize="small">
								<Cube01 />
							</SvgIcon>
      }]
    }, {
      items: [{
        title: "Fix Discount",
        path: paths.fixDiscounts,
        icon: <SvgIcon fontSize="small">
								<BankNote03 />
							</SvgIcon>
      }]
    }, {
      items: [{
        title: "Additional Fee",
        path: paths.additionalFees,
        icon: <SvgIcon fontSize="small">
								<BankNote03 />
							</SvgIcon>
      }]
    }, {
      items: [{
        title: data?.fileAlias?.singular ? data?.fileAlias?.singular + " History" : "Files History",
        path: paths.fileHistory,
        icon: <SvgIcon fontSize="small">
								<ClipboardCheck />
							</SvgIcon>
      }]
    }, permissions.VIEW_REPORT && {
      items: [{
        title: "Reports",
        path: paths.reports,
        icon: <SvgIcon fontSize="small">
								<File07 />
							</SvgIcon>
      }]
    }, permissions.VIEW_FINANCE && {
      items: [{
        title: "Finances",
        path: paths.fiancances,
        icon: <SvgIcon fontSize="small">
								<File07 />
							</SvgIcon>
      }]
    }, permissions.VIEW_FINANCE && {
      items: [{
        title: "Account Transactions",
        path: paths.accountTransactions,
        icon: <SvgIcon fontSize="small">
								<File07 />
							</SvgIcon>
      }]
    }, {
      items: [{
        title: "Settings",
        path: paths.settings,
        icon: <SvgIcon fontSize="small">
								<Settings01 />
							</SvgIcon>
      }]
    }].filter(Boolean) as Section[];

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, permissions, data?.fileAlias]);
};